const wysiegnik = { t: 'Wysięgnik', name: 'wysiegnik', hint: { url: '/arm' }}
export default wysiegnik